export const TransactionStatusTypes = {
    ALL: "All",
    PENDING: "Pending",
    APPROVED: "Approved",
    UNAPPROVED: "Unapproved",
    IN_PROGRESS: "Inprogress",
    REJECTED: "Rejected",
    VERIFIED: "Verified",
    PROCESSING: "Processing",
    REVERTED: "Reverted",
    HOLD: "Hold",
    WIN: "Win",
    OPEN: "Open",
    LOST: "Lost",
    REFUND: "Refund",
    VOID: "Void",
    NOT_ACCEPTED: "Not Accepted",
    HALF_WIN: "Half Win",
    HALF_LOST: "Half Lost",
    CASHOUT: "Cashout",
    CANCELLED: "Cancelled",
    VOIDED: "Voided",
    COMMISSION: "Commission",
    PENDING_PAYMENT: "Pending Payment",
    FAILED: "Failed",
    DECLINED: "Declined",
    SUCCESSFUL: "Successful",
    CONFIRMED: "Confirmed",
    REFUNDED: "Refunded",
    LOSS: "Loss",
    BET: "Bet",
    PROMO_WIN_CREDIT: "PROMO_WIN_CREDIT",
    UNDO: "Undo",
    AWAITED: "Awaited",
    EXPIRED: "Expired",
    CONSUMED: "Consumed",
    UNCLAIMED: "Unclaimed",
    AVAILABLE: "Available",
    ACTIVE: "Active",
    INITIATE_PROCESSING: "Initiate Processing",
};